import React from 'react'

function TextError (props) {
  return <div className=' text-red-800'>{props.children}</div>
}

export default TextError
